import moment from 'moment';
import * as React from 'react';
import { Form } from 'semantic-ui-react';

interface Props {
    fecha: string;
    requerido: boolean;
    alCambiar(fecha: string): void;
}

const FechaNacimiento: React.FunctionComponent<Props> = props => {
    const { fecha, requerido, alCambiar } = props;

    const error = moment(fecha).diff(moment()) > 0; // es en el futuro!

    return (
        <Form.Input
            label='Fecha de nacimiento'
            type='date'
            required={requerido}
            error={error}
            value={fecha}
            onChange={(_e, { value }) => {
                if (value) {
                    const [año = '', mes = '', dia = ''] = value.split('-');
                    alCambiar(`${año.slice(0, 4)}-${mes}-${dia}`);
                } else {
                    alCambiar('');
                }
            }}
            width='4'
        />
    );
};

export default FechaNacimiento;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Personales/componentes/FechaNacimiento.tsx